var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 rounded border-4",class:_vm.getStyleClasses(_vm.type)},[_c('div',{staticClass:"max-w-default mx-auto"},[(_vm.icon)?_c('span',{staticClass:"pr-1",class:_vm.icon}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }